import { render, staticRenderFns } from "./grammatikbok.vue?vue&type=template&id=5fa8e0f4&scoped=true"
import script from "./grammatikbok.vue?vue&type=script&lang=js"
export * from "./grammatikbok.vue?vue&type=script&lang=js"
import style0 from "./grammatikbok.vue?vue&type=style&index=0&id=5fa8e0f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa8e0f4",
  null
  
)

export default component.exports